import './App.css';
import { QuizProvider } from './QuizContext';
import Root from './page/Root';
import Office from './page/Office';
import Page2 from './page/Page2';
import Page3 from './page/Page3';
import Page6 from './page/Page6';
import Mansion from './page/Mansion';
import Room1 from './page/Room1';
import Room2 from './page/Room2';
import Room3 from './page/Room3';
import Room4 from './page/Room4';
import Room5 from './page/Room5';
import Room6 from './page/Room6';
import Coffin from './page/Coffin';
import Ending from './page/Ending';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { createHashRouter, RouterProvider } from 'react-router-dom';

function App() {
  const router = createHashRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        { index: true, element: <Office /> },
        { path: "ceo-office", element: <Page2 /> },
        { path: "office", element: <Office /> },
        { path: "house", element: <Page3 /> },
        { path: "mansion", element: <Mansion /> },

        {
          path: "inside",
          element: <Page6 />,
          children: [
            { index: true, element: <Room1 /> },
            { path: "yard", element: <Room1 /> },
            { path: "living", element: <Room2 /> },
            { path: "kitchen", element: <Room3 /> },
            { path: "bedroom", element: <Room4 /> },
            { path: "study", element: <Room5 /> },
            { path: "basement", element: <Room6 /> },
          ],
        },

        { path: "coffin", element: <Coffin /> },
        { path: "ending", element: <Ending /> },
      ],
    },
  ]);

  return (
    <QuizProvider>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </QuizProvider>
  );
}

export default App;
